module.exports = __webpack_public_path__ + "static/media/loading.c01ebc79.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/loading.gif
// module id = 697
// module chunks = 0